// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
  background-color: #FFF;
}
:host header {
  width: 100%;
  z-index: 1;
}
:host.fixedHeader header {
  position: sticky;
  top: 0;
  padding-top: 14px;
  z-index: 1000;
  background: #FFF;
}
:host h2 {
  font-weight: 700;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 32px;
  font-style: normal;
  letter-spacing: -0.5px;
  margin-bottom: 16px;
  color: #14142B;
  text-align: center;
}
:host .teamsHeader {
  display: none;
}
@media (max-width: 768px) {
  :host > header app-tab-select {
    margin-bottom: -15px;
  }
  :host .teamsHeader {
    display: flex;
    width: 100%;
    border-top: 1px solid rgba(228, 229, 232, 0.9);
    padding-top: 15px;
    border-bottom: 1px solid #C9CBD1;
  }
  :host .teamsHeader > button {
    background: none;
    border: none;
    text-align: center;
    flex: 1;
    font-size: 14px;
    line-height: 42px;
    padding-top: 10px;
    border-bottom: 1px solid transparent;
    outline: none;
    font-weight: 500;
    font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  }
  :host .teamsHeader > button:focus, :host .teamsHeader > button:hover {
    background: rgba(255, 255, 255, 0.5);
  }
  :host .teamsHeader > button.selected {
    color: #3E31FA;
    border-color: #3E31FA;
    border-width: 2px;
  }
}
:host .badgesWrapper, :host .summaryWrapper {
  display: flex;
  min-height: 700px;
  z-index: 0;
}
:host .badgesWrapper .team, :host .summaryWrapper .team {
  flex: 1 1 50%;
}
:host .badgesWrapper .team > h3, :host .summaryWrapper .team > h3 {
  font-weight: 400;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 24px;
  font-style: normal;
  letter-spacing: -0.5px;
  margin-bottom: 16px;
  color: #29395A;
  text-align: center;
}
:host .badgesWrapper .team ul {
  display: flex;
  flex-wrap: wrap;
  padding: 24px 0;
}
:host .badgesWrapper .team ul li {
  display: block;
  flex: 1 1 20%;
}
:host .badgesWrapper .team + .team ul {
  border-left: 1px solid #C9CBD1;
}
:host .summaryWrapper {
  width: 100%;
}
:host .summaryWrapper .team {
  text-align: center;
}
:host .summaryWrapper .team .scrollbox {
  position: relative;
  display: block;
  overflow-x: hidden;
}
:host .summaryWrapper .team .dataWrapper {
  padding: 24px;
}
:host .summaryWrapper .team .dataWrapper .table {
  flex: 1 0 50%;
}
@media (min-width: 768px) {
  .team :host .summaryWrapper .team + .team .dataWrapper {
    border-left: 1px solid #C9CBD1;
  }
}
@media (max-width: 768px) {
  :host .team {
    padding-top: 32px;
  }
  :host h2 {
    font-size: 24px;
    line-height: 24px;
  }
  :host .badgesWrapper, :host .summaryWrapper {
    flex-direction: column;
  }
  :host .badgesWrapper .team > ul, :host .summaryWrapper .team > ul {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/stats/stats/stats.component.scss","webpack://./src/theme.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBCWW;ADZb;AAGE;EACE,WAAA;EACA,UAAA;AADJ;AAKI;EACE,gBAAA;EACA,MAAA;EACA,iBAAA;EACA,aAAA;EACA,gBCFO;ADDb;AAOE;ECuCE,gBAAA;EAQA,+DAAA;EAkDF,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAlFkB;EAmFlB,kBAAA;ADnGF;AACE;EACE,aAAA;AACJ;AAIE;EAEI;IACE,oBAAA;EAHN;EAQE;IACE,aAAA;IACA,WAAA;IACA,8CAAA;IACA,iBAAA;IACA,gCAAA;EANJ;EAOI;IACE,gBAAA;IACA,YAAA;IACA,kBAAA;IACA,OAAA;IACA,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,oCAAA;IACA,aAAA;ICIJ,gBAAA;IAUA,+DAAA;EDjBF;EAKM;IACE,oCAAA;EAHR;EAKM;IACE,cC/DK;IDgEL,qBChEK;IDiEL,iBAAA;EAHR;AACF;AAQE;EACE,aAAA;EACA,iBAAA;EACA,UAAA;AANJ;AAQI;EACE,aAAA;AANN;AAQM;ECpBF,gBAAA;EAYA,+DAAA;EA2DF,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cA7Fc;EA8Fd,kBAAA;ADtDF;AAMM;EACE,aAAA;EACA,eAAA;EACA,eAAA;AAJR;AAMQ;EACE,cAAA;EACA,aAAA;AAJV;AAQM;EACE,8BAAA;AANR;AAWE;EACE,WAAA;AATJ;AAWI;EACE,kBAAA;AATN;AAWM;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AATR;AAgCM;EACE,aAAA;AA9BR;AAgCQ;EACE,aAAA;AA9BV;AAkCM;EACE;IAEE,8BAAA;EAjCR;AACF;AAuCE;EAEE;IACE,iBAAA;EAtCJ;EAyCE;IACE,eAAA;IACA,iBAAA;EAvCJ;EAyCE;IACE,sBAAA;EAvCJ;EAwCI;IACE,uBAAA;EAtCN;AACF","sourcesContent":["@import 'theme';\n\n:host {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 0;\n  background-color: $colorWhite;\n\n  header {\n    width: 100%;\n    z-index: 1;\n  }\n\n  &.fixedHeader {\n    header {\n      position: sticky;\n      top: 0;\n      padding-top: 14px;\n      z-index: 1000;\n      background: $colorWhite;\n    }\n  }\n\n  h2 {\n    @include headingH3();\n  }\n\n  .teamsHeader {\n    display: none;\n  }\n\n\n\n  @media (max-width: $mobileBreakpoint) {\n    > header {\n      app-tab-select {\n        margin-bottom: -15px;\n      }\n    }\n    > header + div {\n    }\n    .teamsHeader {\n      display: flex;\n      width: 100%;\n      border-top: 1px solid transparentize($colorN10, .1);\n      padding-top: 15px;\n      border-bottom: 1px solid $colorN20;\n      > button {\n        background: none;\n        border: none;\n        text-align: center;\n        flex: 1;\n        font-size: 14px;\n        line-height: 42px;\n        padding-top: 10px;\n        border-bottom: 1px solid transparent;\n        outline: none;\n        @include font(medium);\n        &:focus, &:hover {\n          background: transparentize($colorWhite, 0.5);\n        }\n        &.selected {\n          color: $colorPrimary;\n          border-color: $colorPrimary;\n          border-width: 2px;\n        }\n      }\n    }\n  }\n\n  .badgesWrapper, .summaryWrapper {\n    display: flex;\n    min-height: 700px;\n    z-index: 0;\n\n    .team {\n      flex: 1 1 50%;\n\n      > h3 {\n        @include headingH5();\n      }\n    }\n  }\n\n  .badgesWrapper {\n    .team {\n      ul {\n        display: flex;\n        flex-wrap: wrap;\n        padding: 24px 0;\n\n        li {\n          display: block;\n          flex: 1 1 20%;\n        }\n      }\n\n      & + .team  ul {\n        border-left: 1px solid $colorN20;\n      }\n    }\n  }\n\n  .summaryWrapper {\n    width: 100%;\n\n    .team {\n      text-align: center;\n\n      .scrollbox {\n        position: relative;\n        display: block;\n        overflow-x: hidden;\n        // &:before {\n        //   content: '';\n        //   z-index: 2;\n        //   position: absolute;\n        //   left: 0;\n        //   top: 0;\n        //   height: 100%;\n        //   width: 20px;\n        //   background: linear-gradient(to right, rgba(255,255,255, 1), rgba(255,255,255,0));\n        // }\n        // &:after {\n        //   content: '';\n        //   z-index: 2;\n        //   position: absolute;\n        //   right: 0;\n        //   top: 0;\n        //   height: 100%;\n        //   width: 20px;\n        //   background: linear-gradient(to left, rgba(255,255,255, 1), rgba(255,255,255,0));\n        // }\n      }\n\n      .dataWrapper {\n        padding: 24px;\n\n        .table {\n          flex: 1 0 50%;\n        }\n      }\n\n      @media (min-width: $mobileBreakpoint) {\n        .team\n        & + .team .dataWrapper {\n          border-left: 1px solid $colorN20;\n        }\n      }\n    }\n\n  }\n\n  @media (max-width: $mobileBreakpoint) {\n\n    .team {\n      padding-top:32px;\n    }\n\n    h2 {\n      font-size: 24px;\n      line-height: 24px;\n    }\n    .badgesWrapper, .summaryWrapper {\n      flex-direction: column;\n      .team > ul {\n        justify-content: center;\n      }\n    }\n  }\n}\n","$colorPrimary: #3E31FA;\n$colorPrimaryBg: #EEF2FD;\n$colorAccent: #1785FB;\n$colorSecondary: #C8B17B;\n\n$colorAdsBG: #0D0D0D;\n$colorBlack: #000;\n$colorN100: #1A1E29;\n$colorN90: #292D3A;\n$colorN80: #383D4C;\n$colorN70: #4B505F;\n$colorN60: #626775;\n$colorN50: #787D8B;\n$colorN40: #9397A2;\n$colorN30: #AEB1B9;\n$colorN20: #C9CBD1;\n$colorN10: #E4E5E8;\n$colorN05: #F2F2F4;\n$colorWhite: #FFF;\n\n$colorBestPlayer: #F2B701;\n$colorDisabled: $colorN30;\n\n$gridRampComp1: #FFFFFF;\n$gridRampComp2: #FFFFCC;\n$gridRampComp3: #A1DAB4;\n$gridRampComp4: #41B6C4;\n$gridRampComp5: #2C7FB8;\n$gridRampComp6: #253494;\n\n$colorGood: #A2D98C;\n$colorBad: #E73F74;\n$colorLive: #3D923D;\n$colorLiveTooltip: #A2D98C;\n\n$colorNotFound: #DC0032;\n$colorBackgroundTooltip: #0F2145;\n\n$colorGreyPlacehold: #8C95A6;\n$colorGreyTitle: #0F2145;\n$colorGreyLabel: #5E6A83;\n$colorGreyDark: #29395A;\n$colorGreyOffWhite: #FBFDFF;\n$colorGreyOffBlack: #14142B;\n$animationTimeSlow: 2s;\n$animationTimeNormal: 1s;\n$animationTimeFast: .5s;\n$animationTimeBlink: .1s;\n$animationFuncDefault: ease-out;\n$animationFuncAlt: linear;\n\n$mobileBreakpoint: 768px;\n\n@mixin font($weight: normal, $condensed: false) {\n  @if $weight == extra-light {\n    font-weight: 200;\n  } @else if $weight == light {\n    font-weight: 300;\n  } @else if $weight == normal {\n    font-weight: 400;\n  } @else if $weight == medium {\n    font-weight: 500;\n  } @else if $weight == bold {\n    font-weight: 700;\n  } @else if $weight == black {\n    font-weight: 900;\n  }\n\n  @if $condensed == condensed {\n    font-family: 'RM Neue';\n  } @else {\n    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  }\n}\n\n@mixin pseudoElemIcon($file, $height, $width) {\n  content: '';\n  display: inline-block;\n  height: $height;\n  width: $width;\n  background-image: url($file);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n@mixin noselect() {\n  -webkit-touch-callout: none;\n    -webkit-user-select: none;\n     -khtml-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n@mixin button($file: null) {\n  border: none;\n  cursor: pointer;\n  display: flex;\n  padding: 12px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: linear-gradient(8deg, #3E31FA 19.1%, #8760F6 94.27%);\n  color: $colorGreyOffWhite;\n  @include font(medium);\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n\n  @if $file != null {\n    &::before {\n      @include pseudoElemIcon($file, 16px, 16px);\n    }\n  }\n}\n\n@mixin headingH3() {\n  @include font(bold);\n  font-size: 32px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyOffBlack;\n  text-align: center;\n}\n@mixin headingH5() {\n  @include font(normal);\n  font-size: 24px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyDark;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
